import { Component, type OnInit, ChangeDetectionStrategy } from '@angular/core'
import { universalPlusMenu, UniversalPlusMenuItem } from './universal-plus-menu'
import { select, Store } from '@ngrx/store'
import { DataCheckerService, isSomething } from '@tokeet-frontend/tv3-platform'
import { HoldDialogService } from '@tv3/containers/calendar/hold/hold-dialog/hold-dialog.service'
import { ChannelHelperService } from '@tv3/containers/channels/channel-connect/channel-helper.service'
import { GuestDialogService } from '@tv3/containers/guests/dialogs/guest-dialog/guest-dialog.service'
import { InquirySharedDialogsService } from '@tv3/containers/inquiries/dialogs/inquiry-shared-dialogs.service'
import { AccountRatesDialogTab } from '@tv3/containers/rates/account-rates-dialog/account-rates-dialog.component'
import { AccountRatesDialogService } from '@tv3/containers/rates/account-rates-dialog/account-rates-dialog.service'
import { EditRateDialogService } from '@tv3/containers/rates/edit-rate-dialog/edit-rate-dialog.service'
import { AddRentalDialogService } from '@tv3/containers/rentals/add/add-rental-dialog.service'
import { TaskDialogService } from '@tv3/containers/tasks/shared/task-dialog/task-dialog.service'
import { SubscriptionFeatureAccessLimited } from '@tv3/store/plan/plan.actions'
import { PlanTypes } from '@tv3/store/plan/plan.model'
import { selectActiveTokeetPlanView } from '@tv3/store/plan/plan.selectors'
import { of } from 'rxjs'
import { filter, take } from 'rxjs/operators'
import { switchMap } from 'rxjs/operators'
import { AddExpenseDialogService } from '@tv3/containers/expenses/dialogs/add/add-expense-dialog.service'
import { OpenAddRentalDialog } from '@tv3/store/overlay/overlay.actions'
import { Router } from '@angular/router'
import { RateAutomationsGuard } from '@tokeet-frontend/rate-automations'

@Component({
  selector: 'app-global-plus-btn',
  templateUrl: './global-plus-btn.component.html',
  styleUrls: ['./global-plus-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class GlobalPlusBtnComponent implements OnInit {
  universalPlusMenu = universalPlusMenu

  constructor(
    private store: Store<any>,
    private router: Router,
    private inquirySharedDialogsService: InquirySharedDialogsService,
    private addHoldDialog: HoldDialogService,
    private addGuestDialog: GuestDialogService,
    private addExpenseDialog: AddExpenseDialogService,
    private taskDialog: TaskDialogService,
    private channelHelperService: ChannelHelperService,
    private editRateDialogService: EditRateDialogService,
    private accountRatesDialogService: AccountRatesDialogService,
    private dataChecker: DataCheckerService
  ) {}
  ngOnInit(): void {
    this.dataChecker.check([RateAutomationsGuard])
  }

  onMouseoverMainPlusMenuItem(item: UniversalPlusMenuItem, index: number) {
    this.universalPlusMenu.forEach((menuItem, i) => {
      if (i !== index) {
        menuItem.open = false
      } else {
        menuItem.open = true
      }
    })
  }

  onMenuItemClick(item: UniversalPlusMenuItem) {
    if (item.action) {
      this.store.dispatch(item.action)
    }
    if (item.url) {
      this.router.navigate([item.url])
    }
  }

  onAddRental() {
    // this.addRentalDialog.open()
    this.store.dispatch(OpenAddRentalDialog())
  }

  onAddBooking() {
    this.inquirySharedDialogsService.openAddInquiry({
      title: 'Create Booking',
      isBooking: true,
    })
  }

  onAddInquiry() {
    this.inquirySharedDialogsService.openAddInquiry({})
  }

  onAddHoldEvent() {
    this.addHoldDialog.open()
  }

  onAddGuest() {
    this.addGuestDialog.open()
  }

  onAddExpense() {
    this.addExpenseDialog.open()
  }

  onAddTask() {
    this.taskDialog.open()
  }

  onAddStandardRate() {
    this.editRateDialogService.open({ type: 'standard' })
  }

  onAddDynamicRate() {
    this.editRateDialogService.open({ type: 'dynamic' })
  }

  openGroupRates() {
    this.accountRatesDialogService.open({ activeTab: AccountRatesDialogTab.GroupRates })
  }

  onAddChannel() {
    this.store
      .pipe(
        select(selectActiveTokeetPlanView),
        filter((plan) => isSomething(plan)),
        take(1),
        switchMap((plan) => {
          if (plan.isPaid) {
            return this.channelHelperService.connectChannel().afterClosed()
          } else {
            this.store.dispatch(
              SubscriptionFeatureAccessLimited({
                currentPlanType: plan.type,
                requiredPlanType: PlanTypes.Entry,
              })
            )
            return of(null)
          }
        })
      )
      .subscribe()
  }
}
